/* eslint-disable @typescript-eslint/no-empty-interface */
import { GoalType } from 'Generated/graphql-types'

const config = { domain: 'Impact', subdomain: 'Initiatives' }

interface DeleteDataPointClicked {
  reportedMetricGroupId: number
  goalId?: number
}

interface EditDataPointClicked {
  reportedMetricGroupId: number
}

interface CreateInitiativeSubmitted {
  reportedMetricGroupId: number
  reportedMetricGroupTitle: string
}

interface CreateGoalClicked {
  reportedMetricGroupId?: number
}

interface CreateGoalSubmitted {
  reportedMetricCategory?: string
  reportedMetricGroupId?: number
  reportedMetricGroupTitle?: string
  reportedMetricId?: number
  reportedMetricTitle?: string
  reportedMetricOwner?: string | number
  goalCreatedDate: string
  goalUpdatedDate: string
  goalTitle: string
  reportedMetricUpdatedDate?: string
}

// TODO: Remove this once the Chart Wizard is released without the FF 'showGoalWizard'
interface AddGoalMeasurement {
  reportedMetricGroupTitle: string
  reportedMetricGroupId: number
  reportedMetricId: number
  reportedMetricTitle: string
}

interface EditInitiativeSubmitted {
  reportedMetricGroupId: number
  reportedMetricGroupTitle: string
}

interface EditGoalSubmitted {
  reportedMetricId: number
  reportedMetricCategory: string
  reportedMetricOwner: string | number
  goalType: GoalType
  templateLibraryId: number | null
  goalUpdatedDate: string
  goalTitle: string
  initiativeTitle: string
}

interface EditDataPointSubmitted {
  reportedMetricGroupId?: number
  reportedMetricEntryId?: number
  goalId?: number
}

interface ArchiveInitiativeSubmitted {
  reportedMetricGroupId: number
  reportedMetricGroupTitle: string
}

interface ArchiveGoalSubmitted {}

interface ArchiveDataPointSubmitted {
  reportedMetricEntryId: number
}

interface CreateDataPointClicked {
  goalId?: number
}

interface CreateDataPointSubmitted {
  dataPointNumber: number
  initiativeName: string
  reportedMetricEntryId: number
  reportedMetricTitle: string
  reportedMetricUpdatedDate: string
  goalId?: number
}

interface CreateDataPointAbandoned {
  goalId?: number
}

interface EditGoalClicked {
  goalId: number
  goalType: GoalType
  templateLibraryId: number | null
}

interface MagicButtonClicked {
  userid: number
  goalId: number
  goalType: GoalType
  templateLibraryId: number | null
}

interface NavigationToolTip {
  tipId: string
}

interface NavigationItemClicked {}

interface GuideViewed {}

interface DismissGuideClicked {}

interface HideMobileGuideClicked {}

interface RecallGuideClicked {}

interface ExpandGuideClicked {}

interface MinimizeGuideClicked {}

interface GuideCourseClicked {
  courseId: string
  courseTitle: string
}

interface GuideResourceClicked {
  resourceId: string
  resourceName: string
}

interface MissionEventParams {}

interface CreateInitiativeClicked {}

interface ViewExampleClicked {}

interface CloseExampleClicked {}

interface AddQualitativeUpdateClicked {}

interface AddQualitativeUpdateSubmitted {
  goalUpdateId: number
}

interface EditQualitativeUpdateClicked {
  goalUpdateId: number
}

interface EditQualitativeUpdateSubmitted {
  goalUpdateId: number
}

interface DeleteQualitativeUpdateClicked {
  goalUpdateId: number
}

interface ViewAllQualitativeUpdatesClicked {}

interface ViewOrHideGoalDetailsClicked {
  userId: number
  goalId: number
  initiativeId?: number
  goalType: GoalType
}

interface GoalAddTaskClicked {
  userId: number
  goalId: number
  initiativeId: number
}

interface GoalTaskCreated {
  userId: number
  goalId: number
  initiativeId: number
  goalType: GoalType
  templateLibraryId: number | null
}

interface GoalTaskNamed {
  userId: number
  goalId: number
  initiativeId: number
  taskId: number
  taskTitle: string
  goalType: GoalType
  templateLibraryId: number | null
}

interface GoalTaskEdited {
  userId: number
  goalId: number
  initiativeId: number
  taskId: number
  taskTitle: string
  goalType: GoalType
  templateLibraryId: number | null
}

interface GoalTaskCompleted {
  assigneeUserEmail: string
  goalId: number
  goalType: GoalType
  initiativeId: number
  resourceId: string | null
  taskDescription: string
  taskId: number
  taskStatus: boolean
  taskUpdatedDate: string
  templateLibraryId: number | null
  userId: number
  dueDate: string | null
}

interface GoalTaskDeleted {
  userId: number
  goalId: number
  initiativeId: number
  taskId: number
  goalType: GoalType
  templateLibraryId: number | null
}

interface GoalTaskAssigned {
  assigneeUserId: number
  assigneeUserEmail: string
  assignerUserId: number
  goalId: number
  goalType: GoalType
  initiativeId: number
  taskDescription: string
  taskId: number
  taskStatus: string
  taskUpdatedDate: string
  templateLibraryId: number | null
  userId: number
  goalUpdatedDate: string
  goalTaskAssignationStatus: string
  dueDate: string | null
}

interface GoalTaskAssignedNotificationSent {
  userId: number
  goalId: number
  initiativeId: number
  taskId: number
}

interface GoalAutoCreated {
  goalType: GoalType
  templateLibraryId: number
  initiativeId: number
  goalId: number
  goalCreatedDate: string
  goalUpdatedDate: string
  goalTitle: string
  initiativeTitle: string
}

interface GoalTaskAcademyLinked {
  initiativeId: number
  goalId: number
  taskId: number
  resourceId: string
}

interface CreateGoalChartClicked {
  reportedMetricGroupTitle: string
  reportedMetricGroupId: number
  reportedMetricId: number
  reportedMetricTitle: string
}

interface GoalEditChartClicked {
  initiativeId: number
  goalId: number
}
interface CreateGoalChartCancelClicked {
  initiativeId: number
  goalId: number
  lastStepCompleted: number
}

interface CreateGoalChartSubmitted {
  goalId: number
  initiativeId: number
  initiativeName: string
  reportedMetricTitle: string
  reportedMetricUpdatedDate: string
}

interface GoalEditChartSubmitted {
  initiativeId: number
  goalId: number
}

interface GoalEditChartAddCategoryClicked {
  initiativeId: number
  goalId: number
}

interface GoalEditChartDeleteCategoryClicked {
  initiativeId: number
  goalId: number
  categoryTitle: string
}

interface GoalTaskDueDateSubmitted {
  dueDate: string | null
  resourceId: string | null
  taskDescription: string
  taskId: number
  taskStatus: string
  taskUpdatedDate: string
  goalId: string
  goalType: string
  linkText: string | null
  linkUrl: string | null
}
interface GoalTaskDueDateDeleteClicked {
  dueDate: string | null
  resourceId: string | null
  taskDescription: string
  taskId: number
  taskStatus: string
  taskUpdatedDate: string
  goalId: string
  goalType: string
  linkText: string | null
  linkUrl: string | null
}

interface GoalTaskEditTaskClicked {
  dueDate: string | null
  resourceId: string | null
  taskDescription: string
  taskId: number
  taskStatus: string
  taskUpdatedDate: string
  goalId: string
  goalType: string
  linkText: string | null
  linkUrl: string | null
}

interface GoalTaskDuplicateTaskClicked {
  dueDate: string | null
  resourceId: string | null
  taskDescription: string
  taskId: number
  taskStatus: string
  taskUpdatedDate: string
  goalId: string
  goalType: string
  linkText: string | null
  linkUrl: string | null
}

interface GoalTaskDeleteTaskClicked {
  dueDate: string | null
  resourceId: string | null
  taskDescription: string
  taskId: number
  taskStatus: string
  taskUpdatedDate: string
  goalId: string
  goalType: string
  linkText: string | null
  linkUrl: string | null
}

interface GoalTaskAcademyResourceAdded {
  dueDate: string | null
  resourceId: string | null
  taskDescription: string
  taskId: number | null
  taskStatus: string
  taskUpdatedDate: string
  goalId: string
  goalType: string
  linkText: string | null
  linkUrl: string | null
}

interface GoalTaskUrlLinkAdded {
  dueDate: string | null
  resourceId: string | null
  taskDescription: string
  taskId: number | null
  taskStatus: string
  taskUpdatedDate: string
  goalId: string
  goalType: string
  linkText: string | null
  linkUrl: string | null
}

interface GoalTaskUrlTextAdded {
  dueDate: string | null
  resourceId: string | null
  taskDescription: string
  taskId: number | null
  taskStatus: string
  taskUpdatedDate: string
  goalId: string
  goalType: string
  linkText: string | null
  linkUrl: string | null
}

interface GoalTaskSaveClicked {
  dueDate: string | null
  resourceId: string | null
  taskDescription: string
  taskId: number | null
  taskStatus: string
  taskUpdatedDate: string
  goalId: string
  goalType: string
  linkText: string | null
  linkUrl: string | null
}

interface GoalTaskCancelClicked {
  dueDate: string | null
  resourceId: string | null
  taskDescription: string
  taskId: number | null
  taskStatus: string
  taskUpdatedDate: string
  goalId: string
  goalType: string
  linkText: string | null
  linkUrl: string | null
}

interface GoalChartWizardStep1Clicked {
  role: string
  relationship: string
}

interface GoalChartWizardChartTypeSelected {
  role: string
  relationship: string
  chartType: string
}

interface GoalChartWizardStep2Clicked {
  role: string
  relationship: string
}

interface AddCategoryClicked {
  role: string
  relationship: string
}

interface DeleteCategoryClicked {
  role: string
  relationship: string
}

interface GoalChartFilterClicked {
  role: string
  relationship: string
}

interface GoalChartChartTypeSelected {
  role: string
  relationship: string
  chartType: string
}

interface GoalChartChartCalculationSelected {
  role: string
  relationship: string
  chartCalculation: string
}

interface GoalChartDeleteClicked {
  role: string
  relationship: string
}

interface GoalChartDeleteSubmitted {
  role: string
  relationship: string
}

export const initiatives = {
  Create_Goal_Clicked: {
    Create_Goal_Clicked: (param: CreateGoalClicked) => param,
    config,
  },
  Create_Goal_Submitted: {
    Create_Goal_Submitted: (param: CreateGoalSubmitted) => param,
    config,
  },
  // TODO: Remove this event once the Chart Wizard is released without the FF 'showGoalWizard'
  Add_Goal_Measurement_Clicked: {
    Add_Goal_Measurement_Clicked: (param: AddGoalMeasurement) => param,
    config,
  },
  // TODO: Remove this event once the Chart Wizard is released without the FF 'showGoalWizard'
  Add_Goal_Measurement_Submitted: {
    Add_Goal_Measurement_Submitted: (param: AddGoalMeasurement) => param,
    config,
  },
  Edit_Goal_Clicked: {
    Edit_Goal_Clicked: (param: EditGoalClicked) => param,
    config,
  },
  Create_Ai_Story_Clicked: {
    Create_Ai_Story_Clicked: (param: MagicButtonClicked) => param,
    config,
  },
  Edit_Goal_Submitted: {
    Edit_Goal_Submitted: (param: EditGoalSubmitted) => param,
    config,
  },
  Archive_Goal_Submitted: {
    Archive_Goal_Submitted: (param: ArchiveGoalSubmitted) => param,
    config,
  },
  Archive_Initiative_Submitted: {
    Archive_Initiative_Submitted: (param: ArchiveInitiativeSubmitted) => param,
    config,
  },
  Create_Initiative_Submitted: {
    Create_Initiative_Submitted: (param: CreateInitiativeSubmitted) => param,
    config,
  },
  Edit_Initiative_Submitted: {
    Edit_Initiative_Submitted: (param: EditInitiativeSubmitted) => param,
    config,
  },
  Edit_Data_Point_Submitted: {
    Edit_Data_Point_Submitted: (param: EditDataPointSubmitted) => param,
    config,
  },
  Archive_Data_Point_Submitted: {
    Archive_Data_Point_Submitted: (param: ArchiveDataPointSubmitted) => param,
    config,
  },
  Create_Data_Point_Clicked: {
    Data_Point_Clicked: (param: CreateDataPointClicked) => param,
    config,
  },
  Create_Data_Point_Submitted: {
    Data_Point_Submitted: (param: CreateDataPointSubmitted) => param,
    config,
  },
  Create_Data_Point_Abandoned: {
    Data_Point_Abandoned: (param: CreateDataPointAbandoned) => param,
    config,
  },
  Edit_Data_Point_Clicked: {
    Edit_Data_Point_Clicked: (param: EditDataPointClicked) => param,
    config,
  },
  Delete_Data_Point_Clicked: {
    Delete_Data_Point_Clicked: (param: DeleteDataPointClicked) => param,
    config,
  },
  Clicked: {
    Clicked: (param: NavigationItemClicked) => param,
    config,
  },
  Tip_Viewed: {
    Tip_Viewed: (param: NavigationToolTip) => param,
    config,
  },
  Acknowledge_Tip_Clicked: {
    Acknowledge_Tip_Clicked: (param: NavigationToolTip) => param,
    config,
  },
  Celebration_Viewed: {
    Celebration_Viewed: (param: NavigationToolTip) => param,
    config,
  },
  Guide_Viewed: {
    Guide_Viewed: (param: GuideViewed) => param,
    config,
  },
  Dismiss_Guide_Clicked: {
    Dismiss_Guide_Clicked: (param: DismissGuideClicked) => param,
    config,
  },
  Hide_Mobile_Guide_Clicked: {
    Hide_Mobile_Guide_Clicked: (param: HideMobileGuideClicked) => param,
    config,
  },
  Recall_Guide_Clicked: {
    Recall_Guide_Clicked: (param: RecallGuideClicked) => param,
    config,
  },
  Expand_Guide_Clicked: {
    Expand_Guide_Clicked: (param: ExpandGuideClicked) => param,
    config,
  },
  Minimize_Guide_Clicked: {
    Minimize_Guide_Clicked: (param: MinimizeGuideClicked) => param,
    config,
  },
  Guide_Course_Clicked: {
    Guide_Course_Clicked: (param: GuideCourseClicked) => param,
    config,
  },
  Guide_Resource_Clicked: {
    Guide_Resource_Clicked: (param: GuideResourceClicked) => param,
    config,
  },
  Add_Mission_Clicked: {
    Add_Mission_Clicked: (param: MissionEventParams) => param,
    config,
  },
  Edit_Mission_Clicked: {
    Edit_Mission_Clicked: (param: MissionEventParams) => param,
    config,
  },
  Edit_Mission_Save_Clicked: {
    Edit_Mission_Save_Clicked: (param: MissionEventParams) => param,
    config,
  },
  Edit_Mission_Saved: {
    Edit_Mission_Saved: (param: MissionEventParams) => param,
    config,
  },
  Create_Initiative_Clicked: {
    Create_Initiative_Clicked: (param: CreateInitiativeClicked) => param,
    config,
  },
  View_Example_Clicked: {
    View_Example_Clicked: (param: ViewExampleClicked) => param,
    config,
  },
  Close_Example_Clicked: {
    Close_Example_Clicked: (param: CloseExampleClicked) => param,
    config,
  },
  Add_Qualitative_Update_Clicked: {
    Add_Qualitative_Update_Clicked: (param: AddQualitativeUpdateClicked) =>
      param,
    config,
  },
  Add_Qualitative_Update_Submitted: {
    Add_Qualitative_Update_Submitted: (param: AddQualitativeUpdateSubmitted) =>
      param,
    config,
  },
  Edit_Qualitative_Update_Clicked: {
    Edit_Qualitative_Update_Clicked: (param: EditQualitativeUpdateClicked) =>
      param,
    config,
  },
  Edit_Qualitative_Update_Submitted: {
    Edit_Qualitative_Update_Submitted: (
      param: EditQualitativeUpdateSubmitted
    ) => param,
    config,
  },
  Delete_Qualitative_Update_Clicked: {
    Delete_Qualitative_Update_Clicked: (
      param: DeleteQualitativeUpdateClicked
    ) => param,
    config,
  },
  View_All_Qualitative_Updates_Clicked: {
    View_All_Qualitative_Updates_Clicked: (
      param: ViewAllQualitativeUpdatesClicked
    ) => param,
    config,
  },
  View_Goal_Details_Clicked: {
    View_Goal_Details_Clicked: (param: ViewOrHideGoalDetailsClicked) => param,
    config,
  },
  Hide_Goal_Details_Clicked: {
    Hide_Goal_Details_Clicked: (param: ViewOrHideGoalDetailsClicked) => param,
    config,
  },
  Goal_Add_Task_Clicked: {
    Goal_Add_Task_Clicked: (param: GoalAddTaskClicked) => param,
    config,
  },
  Goal_Task_Created: {
    Goal_Task_Created: (param: GoalTaskCreated) => param,
    config,
  },
  Goal_Task_Named: {
    Goal_Task_Named: (param: GoalTaskNamed) => param,
    config,
  },
  Goal_Task_Edited: {
    Goal_Task_Edited: (param: GoalTaskEdited) => param,
    config,
  },
  Goal_Task_Completed: {
    Goal_Task_Completed: (param: GoalTaskCompleted) => param,
    config,
  },
  Goal_Task_Deleted: {
    Goal_Task_Deleted: (param: GoalTaskDeleted) => param,
    config,
  },
  Goal_Task_Assigned: {
    Goal_Task_Assigned: (param: GoalTaskAssigned) => param,
    config,
  },
  Goal_Task_Assigned_Notification_Sent: {
    Goal_Task_Assigned_Notification_Sent: (
      param: GoalTaskAssignedNotificationSent
    ) => param,
    config,
  },
  Goal_Auto_Created: {
    Goal_Auto_Created: (param: GoalAutoCreated) => param,
    config,
  },
  Goal_Task_Academy_Linked: {
    Goal_Task_Academy_Linked: (param: GoalTaskAcademyLinked) => param,
    config,
  },
  Goal_Task_Academy_Link_Clicked: {
    Goal_Task_Academy_Link_Clicked: (param: GoalTaskAcademyLinked) => param,
    config,
  },
  // Create Chart Wizard Analytics
  Goal_Create_Goal_Chart_Clicked: {
    Goal_Create_Goal_Chart_Clicked: (param: CreateGoalChartClicked) => param,
    config,
  },
  Goal_Edit_Chart_Clicked: {
    Goal_Edit_Chart_Clicked: (param: GoalEditChartClicked) => param,
    config,
  },
  Goal_Create_Chart_Wizard_Cancel_Clicked: {
    Goal_Create_Chart_Wizard_Cancel_Clicked: (
      param: CreateGoalChartCancelClicked
    ) => param,
    config,
  },
  Goal_Create_Chart_Submitted: {
    Goal_Create_Chart_Submitted: (param: CreateGoalChartSubmitted) => param,
    config,
  },
  Goal_Edit_Chart_Submitted: {
    Goal_Edit_Chart_Submitted: (param: GoalEditChartSubmitted) => param,
    config,
  },
  Goal_Edit_Chart_Add_Category_Clicked: {
    Goal_Edit_Chart_Add_Category_Clicked: (
      param: GoalEditChartAddCategoryClicked
    ) => param,
    config,
  },
  Goal_Edit_Chart_Delete_Category_Clicked: {
    Goal_Edit_Chart_Delete_Category_Clicked: (
      param: GoalEditChartDeleteCategoryClicked
    ) => param,
    config,
  },
  Goal_Task_DueDate_Submitted: {
    Goal_Task_DueDate_Submitted: (param: GoalTaskDueDateSubmitted) => param,
    config,
  },
  Goal_Task_DueDate_Delete_Clicked: {
    Goal_Task_DueDate_Delete_Clicked: (param: GoalTaskDueDateDeleteClicked) =>
      param,
    config,
  },
  Goal_Task_EditTask_Clicked: {
    Goal_Task_EditTask_Clicked: (param: GoalTaskEditTaskClicked) => param,
    config,
  },
  Goal_Task_DuplicateTask_Clicked: {
    Goal_Task_DuplicateTask_Clicked: (param: GoalTaskDuplicateTaskClicked) =>
      param,
    config,
  },
  Goal_Task_DeleteTask_Clicked: {
    Goal_Task_DeleteTask_Clicked: (param: GoalTaskDeleteTaskClicked) => param,
    config,
  },
  Goal_Task_Academy_Resource_Added: {
    Goal_Task_Academy_Resource_Added: (param: GoalTaskAcademyResourceAdded) =>
      param,
    config,
  },
  Goal_Task_URL_Link_Added: {
    Goal_Task_URL_Link_Added: (param: GoalTaskUrlLinkAdded) => param,
    config,
  },
  Goal_Task_URL_Text_Added: {
    Goal_Task_URL_Text_Added: (param: GoalTaskUrlTextAdded) => param,
    config,
  },
  Goal_Task_Save_Clicked: {
    Goal_Task_Save_Clicked: (param: GoalTaskSaveClicked) => param,
    config,
  },
  Goal_Task_Cancel_Clicked: {
    Goal_Task_Cancel_Clicked: (param: GoalTaskCancelClicked) => param,
    config,
  },
  Goal_Chart_Wizard_Step1_Clicked: {
    Goal_Chart_Wizard_Step1_Clicked: (param: GoalChartWizardStep1Clicked) =>
      param,
    config,
  },

  Goal_Chart_Wizard_ChartType_Selected: {
    Goal_Chart_Wizard_ChartType_Selected: (
      param: GoalChartWizardChartTypeSelected
    ) => param,
    config,
  },

  Goal_Chart_Wizard_Step2_Clicked: {
    Goal_Chart_Wizard_Step2_Clicked: (param: GoalChartWizardStep2Clicked) =>
      param,
    config,
  },
  Add_Category_Clicked: {
    Add_Category_Clicked: (param: AddCategoryClicked) => param,
    config,
  },
  Delete_Category_Clicked: {
    Delete_Category_Clicked: (param: DeleteCategoryClicked) => param,
    config,
  },
  Goal_Chart_Filter_Clicked: {
    Goal_Chart_Filter_Clicked: (param: GoalChartFilterClicked) => param,
    config,
  },
  Goal_Chart_Chart_Type_Selected: {
    Goal_Chart_Chart_Type_Selected: (param: GoalChartChartTypeSelected) =>
      param,
    config,
  },
  Goal_Chart_Chart_Calculation_Selected: {
    Goal_Chart_Chart_Calculation_Selected: (
      param: GoalChartChartCalculationSelected
    ) => param,
    config,
  },
  Goal_Chart_Delete_Clicked: {
    Goal_Chart_Delete_Clicked: (param: GoalChartDeleteClicked) => param,
    config,
  },
  Goal_Chart_Delete_Submitted: {
    Goal_Chart_Delete_Submitted: (param: GoalChartDeleteSubmitted) => param,
    config,
  },
}
